(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-information-content"] && !Shopify.designMode) return;
  try {
    (() => {
    /*
      =========================================================
      ZERO FOXTROT
      MOBILE PRODUCT INFORMATION ORDER

      MOBILE:
      1. Product summary above media
         - title
         - reviews
         - price
         - divider / normal summary content

      2. Product gallery

      3. Product controls
         - variants
         - add to cart

      4. Supporting PDP blocks
         - feature callout
         - PDP offer

      5. Product accordion / description

      DESKTOP:
      Restore original Theme Editor block order.
      =========================================================
    */

    if (window.__zfMobileProductSummaryReorder) return;

    window.__zfMobileProductSummaryReorder = true;

    const mobileQuery =
      window.matchMedia('(max-width: 749px)');

    let refreshFrame = null;


    /* =========================================================
       HELPERS
       ========================================================= */

    const findDirectChild = (
      container,
      descendant
    ) => {
      if (!container || !descendant) {
        return null;
      }

      let node = descendant;

      while (
        node &&
        node.parentElement !== container
      ) {
        node = node.parentElement;
      }

      return (
        node &&
        node.parentElement === container
          ? node
          : null
      );
    };


    /*
      A block might currently live either in the normal
      product-details container OR in our mobile summary.

      Search both.
    */
    const findBlockAcrossContainers = (
      groupContent,
      summary,
      selector
    ) => {
      const normalDescendant =
        groupContent.querySelector(selector);

      if (normalDescendant) {
        return findDirectChild(
          groupContent,
          normalDescendant
        );
      }

      const summaryDescendant =
        summary.querySelector(selector);

      if (summaryDescendant) {
        return findDirectChild(
          summary,
          summaryDescendant
        );
      }

      return null;
    };


    const getParts = (root) => {
      const summary =
        root.querySelector(
          ':scope > [data-zf-mobile-product-summary]'
        );

      const details =
        root.querySelector(
          ':scope > .product-details'
        );

      if (!summary || !details) {
        return null;
      }

      const groupContent =
        details.querySelector(
          ':scope > .group-block > .group-block-content'
        ) ||
        details.querySelector(
          '.group-block-content'
        );

      if (!groupContent) {
        return null;
      }


      /* -------------------------
         VARIANT PICKER
         ------------------------- */

      const picker =
        groupContent.querySelector(
          'variant-picker'
        );

      const pickerBlock =
        findDirectChild(
          groupContent,
          picker
        );

      if (!pickerBlock) {
        return null;
      }


      /* -------------------------
         BUY BUTTONS
         ------------------------- */

      const buyButtons =
        groupContent.querySelector(
          '.buy-buttons-block'
        );

      const buyButtonsBlock =
        findDirectChild(
          groupContent,
          buyButtons
        );


      /* -------------------------
         FEATURE CALLOUT
         ------------------------- */

      const featureCalloutBlock =
        findBlockAcrossContainers(
          groupContent,
          summary,
          '.zf-product-feature-callout'
        );


      /* -------------------------
         PDP OFFER
         ------------------------- */

      const offerBlock =
        findBlockAcrossContainers(
          groupContent,
          summary,
          '.zf-pdp-offer'
        );


      /* -------------------------
         DESCRIPTION / ACCORDION
         ------------------------- */

      const accordion =
        groupContent.querySelector(
          '.zf-pdp-accordion'
        );

      const accordionBlock =
        findDirectChild(
          groupContent,
          accordion
        );


      return {
        summary,
        groupContent,
        pickerBlock,
        buyButtonsBlock,
        featureCalloutBlock,
        offerBlock,
        accordionBlock
      };
    };


    /* =========================================================
       MOBILE
       ========================================================= */

    const organizeMobile = (root) => {
      const parts =
        getParts(root);

      if (!parts) return;

      const {
        summary,
        groupContent,
        pickerBlock,
        buyButtonsBlock,
        featureCalloutBlock,
        offerBlock,
        accordionBlock
      } = parts;


      /*
        These blocks must NEVER live in the summary
        above the product image.
      */
      const supportingBlocks = [
        featureCalloutBlock,
        offerBlock
      ].filter(Boolean);


      /*
        If an older version of this script already moved
        either supporting block into the summary, put it
        back into product-details first.
      */
      supportingBlocks.forEach(
        (element) => {
          if (
            element.parentElement === summary
          ) {
            groupContent.insertBefore(
              element,
              pickerBlock
            );
          }
        }
      );


      /*
        Determine all normal product detail blocks currently
        sitting before the variant picker.
      */
      const children =
        Array.from(
          groupContent.children
        );

      const pickerIndex =
        children.indexOf(
          pickerBlock
        );


      /*
        Move ordinary summary content above media.

        IMPORTANT:
        Feature Callout and PDP Offer are explicitly excluded.
      */
      if (pickerIndex > 0) {
        const computed =
          window.getComputedStyle(
            groupContent
          );

        const gap =
          computed.rowGap !== 'normal'
            ? computed.rowGap
            : computed.gap;

        if (
          gap &&
          gap !== 'normal'
        ) {
          summary.style.gap =
            gap;
        }

        children
          .slice(
            0,
            pickerIndex
          )
          .filter(
            (element) =>
              !element.classList.contains(
                'view-product-title'
              ) &&
              !supportingBlocks.includes(
                element
              )
          )
          .forEach(
            (element) => {
              summary.appendChild(
                element
              );
            }
          );
      }


      summary.hidden =
        summary.children.length === 0;


      /*
        =====================================================
        MOVE SUPPORTING CONTENT BELOW ADD TO CART

        Desired mobile order:

        Buy Buttons
        Feature Callout
        PDP Offer
        Accordion
        =====================================================
      */

      if (buyButtonsBlock) {
        let anchor =
          buyButtonsBlock;

        supportingBlocks.forEach(
          (element) => {
            if (!element) return;

            anchor.insertAdjacentElement(
              'afterend',
              element
            );

            anchor =
              element;
          }
        );
      }

      /*
        Fallback:
        if the Buy Buttons block can't be found for some
        unusual product configuration, at least place these
        immediately before the accordion.
      */
      else if (accordionBlock) {
        supportingBlocks.forEach(
          (element) => {
            groupContent.insertBefore(
              element,
              accordionBlock
            );
          }
        );
      }
    };


    /* =========================================================
       DESKTOP
       Restore Theme Editor order
       ========================================================= */

    const restoreDesktopOrder = (root) => {
      const parts =
        getParts(root);

      if (!parts) return;

      const {
        summary,
        groupContent,
        pickerBlock,
        featureCalloutBlock,
        offerBlock
      } = parts;


      /*
        Put everything from the mobile summary back
        immediately before the variant picker.
      */
      Array.from(
        summary.children
      ).forEach(
        (element) => {
          groupContent.insertBefore(
            element,
            pickerBlock
          );
        }
      );


      /*
        Restore original desktop order:

        Feature Callout
        PDP Offer
        Variant Picker
      */
      if (featureCalloutBlock) {
        groupContent.insertBefore(
          featureCalloutBlock,
          pickerBlock
        );
      }

      if (offerBlock) {
        groupContent.insertBefore(
          offerBlock,
          pickerBlock
        );
      }


      summary.hidden = true;

      summary.style.removeProperty(
        'gap'
      );
    };


    /* =========================================================
       MAIN ORGANIZER
       ========================================================= */

    const organize = () => {
      document
        .querySelectorAll(
          '[data-product-grid-content]'
        )
        .forEach(
          (root) => {
            if (
              mobileQuery.matches
            ) {
              organizeMobile(
                root
              );
            } else {
              restoreDesktopOrder(
                root
              );
            }
          }
        );
    };


    const queueOrganize = () => {
      if (refreshFrame) {
        cancelAnimationFrame(
          refreshFrame
        );
      }

      refreshFrame =
        requestAnimationFrame(
          () => {
            refreshFrame = null;

            organize();
          }
        );
    };


    /* =========================================================
       INITIAL LOAD
       ========================================================= */

    if (
      document.readyState ===
      'loading'
    ) {
      document.addEventListener(
        'DOMContentLoaded',
        queueOrganize,
        {
          once: true
        }
      );
    } else {
      queueOrganize();
    }


    /* =========================================================
       BREAKPOINT CHANGES
       ========================================================= */

    if (
      typeof mobileQuery.addEventListener ===
      'function'
    ) {
      mobileQuery.addEventListener(
        'change',
        queueOrganize
      );
    } else {
      mobileQuery.addListener(
        queueOrganize
      );
    }


    /* =========================================================
       SHOPIFY THEME EDITOR
       ========================================================= */

    document.addEventListener(
      'shopify:section:load',
      queueOrganize
    );

    document.addEventListener(
      'shopify:block:select',
      queueOrganize
    );


    /* =========================================================
       VARIANT CHANGES

       Horizon can update/morph parts of the PDP after
       variant selection, so organize once immediately and
       again after Horizon finishes.
       ========================================================= */

    document.addEventListener(
      'shopify:product:select',
      (event) => {
        queueOrganize();

        if (
          event.promise &&
          typeof event.promise.then ===
            'function'
        ) {
          event.promise
            .then(
              () => {
                requestAnimationFrame(
                  () => {
                    requestAnimationFrame(
                      queueOrganize
                    );
                  }
                );
              }
            )
            .catch(
              () => {}
            );
        } else {
          setTimeout(
            queueOrganize,
            150
          );
        }
      }
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
